import { render, staticRenderFns } from "./camembertChart.vue?vue&type=template&id=68525e10&scoped=true"
import script from "./camembertChart.vue?vue&type=script&lang=js"
export * from "./camembertChart.vue?vue&type=script&lang=js"
import style0 from "./camembertChart.vue?vue&type=style&index=0&id=68525e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68525e10",
  null
  
)

export default component.exports